import GetArticleDetailImageByIdRequestModelBase from '../_generated/modelBases/get-article-detail-image-by-id-request-model-base';

export default class GetArticleDetailImageByIdRequestModel extends GetArticleDetailImageByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
